export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const selectUserHydrated = (state) => state.auth.userHydrated;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectSessionExpired = (state) => state.auth.sessionExpired;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;
export const selectOtpId = (state) => state.auth.otpId;
export const selectAccessToken = (state) => state.auth.accessToken;
export const selectRefreshToken = (state) => state.auth.refreshToken;
